import DefaultStoreDownload from './components/DefaultStoreDownload';
import HriStoreDownload from './components/HriStoreDownload';
import generateRender from 'shared/utils/generateRender';

const StoreDownload = generateRender({
  default: DefaultStoreDownload,
  hri: HriStoreDownload,
});

export default StoreDownload;

